/* LoveÉcru · Product page v2 behaviour (sections/le-pdp-v2.liquid)
   - gallery counter ("2 / 8") for the native Flickity / scroll gallery
   - sticky add-to-cart bar once the main button scrolls away (price, label, variant kept in sync)
   - delivery estimate dates (business-day dispatch + transit, from the block settings)
   - one-tap quick add on cross-sell cards (theme cart drawer opens)
   - recently viewed products (localStorage, rendered client-side)
   - animated accordions, "Read more" collapse, Klaviyo back-in-stock trigger
   The theme's own product form, variant switching and cart drawer are untouched. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }
  function formatRange(a, b) {
    var lang = document.documentElement.lang || 'en';
    try {
      var fmt = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' });
      if (typeof fmt.formatRange === 'function') return fmt.formatRange(a, b);
      return fmt.format(a) + ' – ' + fmt.format(b);
    } catch (e) {
      return a.toDateString() + ' – ' + b.toDateString();
    }
  }
  function fillEta(root) {
    root.querySelectorAll('[data-le-eta]').forEach(function (el) {
      var label = el.querySelector('[data-le-eta-label]');
      if (!label) return;
      var now = new Date();
      var from = new Date(addBusinessDays(now, +el.dataset.leEtaDispatchMin || 0).getTime());
      from.setDate(from.getDate() + (+el.dataset.leEtaTransitMin || 0));
      var to = new Date(addBusinessDays(now, +el.dataset.leEtaDispatchMax || 0).getTime());
      to.setDate(to.getDate() + (+el.dataset.leEtaTransitMax || 0));
      var text = (el.dataset.leEtaText || '[range]').replace('[range]', formatRange(from, to));
      if (label.textContent !== text) label.textContent = text;
    });
  }

  /* ---------- USD amounts in copy → visitor's currency (Shopify Markets rate) ---------- */
  function localiseMoney(root) {
    var cur = window.Shopify && window.Shopify.currency;
    if (!cur || !cur.active || !cur.rate || cur.active === 'USD') return;
    var rate = parseFloat(cur.rate);
    if (!(rate > 0)) return;
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active, maximumFractionDigits: 0, minimumFractionDigits: 0 }); } catch (e) { return; }
    root.querySelectorAll('[data-le-usd]').forEach(function (el) {
      var usd = parseFloat(el.getAttribute('data-le-usd'));
      if (!(usd > 0)) return;
      /* rounded up, so a basket at the shown amount always qualifies */
      var text = fmt.format(Math.ceil(usd * rate));
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* ---------- Quick add (cross-sell cards) ---------- */
  function quickAdd(button) {
    if (button.dataset.leBusy === '1') return;
    var id = button.dataset.leQuickAdd;
    var label = button.querySelector('[data-le-quick-label]');
    var original = label ? label.textContent : '';
    button.dataset.leBusy = '1';
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    var cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
    var added = false;
    fetch(cartRoute + '/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: 'id=' + encodeURIComponent(id) + '&quantity=1'
    }).then(function (res) {
      if (!res.ok) { var error = new Error('add failed'); error.rejected = res.status >= 400 && res.status < 500; throw error; }
      return res.json();
    }).then(function (item) {
      added = true;
      return fetch(cartRoute + '.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart refresh failed'); return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: item }, bubbles: true }));
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        if (label) label.textContent = button.getAttribute('data-le-added-label') || 'Added';
        setTimeout(function () {
          button.classList.remove('is-added');
          if (label) label.textContent = original;
          button.dataset.leBusy = '0';
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1800);
      });
    }).catch(function (error) {
      button.dataset.leBusy = '0';
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      window.location.href = !added && error.rejected && button.dataset.leQuickUrl ? button.dataset.leQuickUrl : cartRoute;
    });
  }

  /* ---------- Recently viewed ---------- */
  var RECENT_KEY = 'le_recent_v1';
  function readRecent() {
    try { var v = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* storage unavailable: feature simply stays off */ }
  }
  function recentlyViewed(root) {
    var self = parseJSON(root.querySelector('[data-le-recent-self]'));
    var box = root.querySelector('[data-le-recent]');
    var list = readRecent();
    if (box) {
      var track = box.querySelector('[data-le-recent-track]');
      var limit = +box.dataset.leRecentLimit || 6;
      var others = list.filter(function (p) { return p && p.h && (!self || p.h !== self.h) && p.i && p.t && p.u; }).slice(0, limit);
      if (track && others.length) {
        track.innerHTML = others.map(function (p) {
          return '<a class="le-v2__cross-card le-v2__recent-card" href="' + p.u.replace(/"/g, '&quot;') + '">' +
            '<img class="le-v2__cross-img" src="' + p.i.replace(/"/g, '&quot;') + '" alt="" loading="lazy" width="160" height="160">' +
            '<span class="le-v2__cross-title">' + String(p.t).replace(/[<>&]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; }) + '</span></a>';
        }).join('');
        box.hidden = false;
      }
    }
    if (self && self.h) {
      var next = list.filter(function (p) { return p && p.h !== self.h; });
      next.unshift(self);
      writeRecent(next);
    }
  }

  /* ---------- Accordions: animate open/close (delegated, so it survives variant-change morphs) ---------- */
  function animateDetails(root) {
    if (reduceMotion || !('animate' in Element.prototype) || root.dataset.leAccDelegated === '1') return;
    root.dataset.leAccDelegated = '1';
    root.addEventListener('click', function (event) {
      var summary = event.target.closest('details.le-v2__acc > summary');
      if (!summary) return;
      var details = summary.parentElement;
      var body = details.querySelector('.le-v2__acc-body');
      if (!body) return;
      if (details.dataset.leAnimating === '1') { event.preventDefault(); return; }
      if (details.open) {
        event.preventDefault();
        details.dataset.leAnimating = '1';
        var h = body.offsetHeight;
        body.style.overflow = 'hidden';
        var closing = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 180, easing: 'ease-out' });
        closing.onfinish = function () { details.open = false; body.style.overflow = ''; details.dataset.leAnimating = '0'; };
      } else {
        details.dataset.leAnimating = '1';
        requestAnimationFrame(function () {
          var h = body.offsetHeight;
          body.style.overflow = 'hidden';
          var opening = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 220, easing: 'ease-out' });
          opening.onfinish = function () { body.style.overflow = ''; details.dataset.leAnimating = '0'; };
        });
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.leV2Init === '1') return;
    root.dataset.leV2Init = '1';
    document.body.classList.add('le-v2-page');

    var variants = parseJSON(root.querySelector('[data-le-variants-data]')) || [];
    var variantById = function (id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    };

    /* ---------- Gallery counter ---------- */
    var slideshow = root.querySelector('[data-product-slideshow]');
    var counter = root.querySelector('[data-le-counter-current]');
    if (slideshow && counter) {
      var cells = Array.prototype.slice.call(slideshow.querySelectorAll('.product__media'));
      var setIndex = function (idx) {
        var next = String(Math.min(Math.max(idx, 0), cells.length - 1) + 1);
        if (counter.textContent !== next) counter.textContent = next;
      };
      var fromClass = function () {
        var selected = slideshow.querySelector('.product__media.is-selected');
        if (selected) setIndex(cells.indexOf(selected));
      };
      var observer = new MutationObserver(fromClass);
      cells.forEach(function (cell) { observer.observe(cell, { attributes: true, attributeFilter: ['class'] }); });
      var frame = 0;
      var fromScroll = function () {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          if (slideshow.classList.contains('flickity-enabled') && slideshow.querySelector('.flickity-viewport')) return;
          var left = slideshow.scrollLeft, best = 0, bestDist = Infinity;
          cells.forEach(function (cell, i) {
            var d = Math.abs(cell.offsetLeft - left);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          setIndex(best);
        });
      };
      slideshow.addEventListener('scroll', fromScroll, { passive: true });
      fromClass();
    }

    /* ---------- Delivery estimate + local-currency amounts ---------- */
    fillEta(root);
    localiseMoney(root);

    /* ---------- Sticky add-to-cart ---------- */
    var sticky = root.querySelector('[data-le-sticky]');
    var mainButton = function () { return root.querySelector('[data-le-main-atc]'); };
    var bisButton = function () { return root.querySelector('[data-le-bis]'); };
    root.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-product-form]')) return;
      var button = mainButton();
      if (button && (button.disabled || button.classList.contains('loading'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    var syncAvailability = function () {
      var button = mainButton(), bis = bisButton();
      if (button && bis) {
        var soldOut = !!button.disabled;
        if (bis.hidden === soldOut) bis.hidden = !soldOut;
      }
    };
    syncAvailability();
    if (sticky && 'IntersectionObserver' in window) {
      sticky.inert = true;
      var observed = null;
      var stickyShouldShow = false;
      var updateStickyVisibility = function () {
        var overlayOpen = document.querySelector('.drawer--visible, .search__predictive.is-visible');
        var show = stickyShouldShow && !overlayOpen;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.inert = !show;
        document.body.classList.toggle('le-v2-sticky-visible', show);
      };
      var overlayObserver = new MutationObserver(updateStickyVisibility);
      document.querySelectorAll('[data-drawer], .search__predictive').forEach(function (overlay) {
        overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class'] });
      });
      document.addEventListener('theme:scroll:lock', updateStickyVisibility);
      document.addEventListener('theme:scroll:unlock', updateStickyVisibility);
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        stickyShouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStickyVisibility();
      }, { threshold: 0 });
      var watch = function () {
        var button = mainButton();
        if (!button || button === observed) return;
        if (observed) io.unobserve(observed);
        observed = button;
        io.observe(button);
      };
      watch();

      var stickyPrice = sticky.querySelector('[data-le-sticky-price]');
      var stickyCompare = sticky.querySelector('[data-le-sticky-compare]');
      var stickyButton = sticky.querySelector('[data-le-sticky-btn]');
      var stickyLabel = sticky.querySelector('[data-le-sticky-label]');
      var stickyVariant = sticky.querySelector('[data-le-sticky-variant]');
      var stickyImage = sticky.querySelector('.le-v2__sticky-img');
      /* Every write below is guarded (only when the value differs) and mutations inside the
         sticky bar or the counter are ignored, so the observer can never re-trigger itself. */
      var syncing = false;
      var setText = function (el, text) { if (el && el.textContent !== text) el.textContent = text; };
      var sync = function () {
        if (syncing) return;
        syncing = true;
        try {
          var price = root.querySelector('[data-product-price]');
          var compare = root.querySelector('[data-compare-price]');
          var button = mainButton();
          var label = root.querySelector('[data-add-to-cart-text]');
          if (price) setText(stickyPrice, price.textContent.trim());
          if (stickyCompare) {
            var compareText = compare ? compare.textContent.trim() : '';
            if (compareText) { setText(stickyCompare, compareText); if (stickyCompare.hidden) stickyCompare.hidden = false; }
            else if (!stickyCompare.hidden) stickyCompare.hidden = true;
          }
          if (button && stickyButton) {
            var busy = button.classList.contains('loading');
            var disabled = button.disabled || busy;
            if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
            if (stickyButton.getAttribute('aria-busy') !== String(busy)) stickyButton.setAttribute('aria-busy', String(busy));
            if (label) setText(stickyLabel, label.textContent.trim());
          }
          var idInput = root.querySelector('[data-le-variant-id]');
          var v = idInput ? variantById(idInput.value) : null;
          if (v && stickyVariant && v.title && v.title !== 'Default Title') setText(stickyVariant, v.title);
          if (v && stickyImage && v.image && stickyImage.getAttribute('src') !== v.image) {
            stickyImage.removeAttribute('srcset');
            stickyImage.setAttribute('src', v.image);
          }
          syncAvailability();
          fillEta(root);
          localiseMoney(root);
          watch();
        } finally { syncing = false; }
      };
      var syncObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'class' && target !== mainButton()) continue;
          if (sticky.contains(target) || (counter && counter.contains(target))) continue;
          sync();
          return;
        }
      });
      syncObserver.observe(root.querySelector('.product-page') || root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      root.addEventListener('le:variant:change', function () { setTimeout(sync, 50); setTimeout(sync, 700); });
      sync();
    } else {
      root.addEventListener('le:variant:change', function () { setTimeout(function () { syncAvailability(); fillEta(root); }, 400); });
    }

    /* ---------- Hidden variant id mirror (used by the gift message + sticky bar) ---------- */
    root.addEventListener('le:variant:change', function (event) {
      var input = root.querySelector('[data-le-variant-id]');
      if (input && event.detail && event.detail.id) input.value = event.detail.id;
    });

    /* ---------- Back in stock (Klaviyo form) ---------- */
    root.addEventListener('click', function (event) {
      var bis = event.target.closest('[data-le-bis]');
      if (!bis) return;
      var formId = bis.dataset.leBisForm;
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });

    /* ---------- Quick add ---------- */
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-le-quick-add]');
      if (!button) return;
      event.preventDefault();
      quickAdd(button);
    });

    /* ---------- Recently viewed ---------- */
    recentlyViewed(root);

    /* ---------- Accordions ---------- */
    animateDetails(root);

    /* ---------- Description: read more ---------- */
    var prose = root.querySelector('[data-le-prose]');
    if (prose && prose.classList.contains('le-v2__prose--collapsible')) {
      var body = prose.querySelector('[data-le-prose-body]');
      var toggle = prose.querySelector('[data-le-prose-toggle]');
      var more = prose.querySelector('[data-le-more]');
      var less = prose.querySelector('[data-le-less]');
      var measure = function () {
        if (!body || !toggle || prose.dataset.leProseReady === '1') return;
        var lineHeight = parseFloat(getComputedStyle(body).fontSize) || 19;
        var limit = lineHeight * 11.5 + 4;
        if (body.scrollHeight > limit + 40) {
          prose.classList.add('is-collapsed');
          toggle.hidden = false;
          prose.dataset.leProseReady = '1';
        }
      };
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      window.addEventListener('load', measure);
      if (toggle) {
        toggle.addEventListener('click', function () {
          var collapsed = prose.classList.toggle('is-collapsed');
          toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          if (more) more.hidden = !collapsed;
          if (less) less.hidden = collapsed;
          if (collapsed) prose.scrollIntoView({ block: 'nearest' });
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-le-pdp-v2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-le-pdp-v2]') : null;
    if (root) { delete root.dataset.leV2Init; init(root); }
  });
})();

